export function createDetailRowAccessorService(deps) {
    // panel type から detailData 内の明細配列を引き当てます。
    function getDetailRowsByPanelType(detailData, panelType) {
        if (deps.isEmpty(detailData)) return [];
        const typeKey = deps.normalizeTypeKey(panelType);
        if (deps.isEmpty(typeKey)) return [];
        const hitKey = Object.keys(detailData).find((key) => deps.normalizeTypeKey(key) === typeKey);
        if (deps.isEmpty(hitKey)) return [];
        return Array.isArray(detailData[hitKey]) ? detailData[hitKey] : [];
    }

    // grid panel から表示元の明細配列を引き当てます。
    function pickDetailRows(detailData, gridPanel) {
        if (deps.isEmpty(detailData) || deps.isEmpty(gridPanel)) return null;
        const typeKey = deps.normalizeTypeKey(gridPanel.type);
        if (deps.isEmpty(typeKey)) return null;
        const keys = Object.keys(detailData ?? {}).map((key) => ({
            raw: key,
            norm: deps.normalizeTypeKey(key)
        }));
        const byType = keys.find((key) => key.norm === typeKey);
        if (deps.isEmpty(byType)) return null;
        return Array.isArray(detailData[byType.raw]) ? detailData[byType.raw] : detailData[byType.raw];
    }

    // panel type の先頭有効行を返します。
    function getFirstDetailRowByPanelType(detailData, panelType) {
        const rows = getDetailRowsByPanelType(detailData, panelType);
        if (!Array.isArray(rows) || rows.length === 0) return null;
        const row = rows.find((item) => !deps.isEmpty(item) && typeof item === "object");
        return deps.isEmpty(row) ? null : row;
    }

    // detail 113 からグループ管理state用の行を組み立てます。
    // (登録グループ(125)の画面・明細は廃止済み。グループトグル・色構成の内部stateにのみ使う)
    function resolveRegisteredGroupRows(detailData = deps.entrydetailRef.current) {
        const baseRows = getDetailRowsByPanelType(detailData, deps.FUKUSHIZAI_BASE_PANEL_TYPE);
        if (!Array.isArray(baseRows) || baseRows.length === 0) return [];

        const seen = new Set();
        const registeredRows = [];

        baseRows.forEach((row) => {
            const item = deps.normalizeItemCd(deps.readRowValueIgnoreCase(row, deps.FUKUSHIZAI_FIELD.ITEM_CD));
            const group = deps.normalizeGroupNo(deps.readRowValueIgnoreCase(row, deps.FUKUSHIZAI_FIELD.GROUP_NO));
            const color = deps.normalizeColorCd(deps.readRowValueIgnoreCase(row, deps.FUKUSHIZAI_FIELD.COLOR_CD));
            if (item === "" || group === "" || color === "") return;

            const key = `${item}|${color}|${group}`;
            if (seen.has(key)) return;

            seen.add(key);
            registeredRows.push(deps.makeRegisteredGroupRow(item, group, color, registeredRows));
        });

        return registeredRows;
    }

    return {
        pickDetailRows,
        getDetailRowsByPanelType,
        getFirstDetailRowByPanelType,
        resolveRegisteredGroupRows
    };
}
